<template>
  <CardBase>
    <CardHeadingWithDescriptionAction :title="props.hold.title">
      <template #actions>
        <DropdownBase v-if="props.hold.can.update || props.hold.can.delete">
          <template #trigger>
            <DropdownButton />
          </template>

          <DropdownItemGroup>
            <DropdownItem
              v-if="props.hold.can.update"
              @click="showingHoldFormModal = true"
              type="edit"
            />

            <DropdownItem
              v-if="props.hold.can.delete"
              @click="deleteHold"
              type="delete"
            />
          </DropdownItemGroup>
        </DropdownBase>
      </template>
    </CardHeadingWithDescriptionAction>
    <DescriptionList columns="grid-cols-1 sm:grid-cols-2">
      <DescriptionListItem
        title="From"
        :description="props.hold.formatted_from_date"
      />
      <DescriptionListItem
        title="To"
        :description="props.hold.formatted_to_date"
      />
      <DescriptionListItem
        v-if="props.hold.description"
        full
        title="Details"
        :description="props.hold.description"
      />
    </DescriptionList>

    <HoldFormModal
      :hold="props.hold"
      :show="showingHoldFormModal"
      @close="showingHoldFormModal = false"
    />
  </CardBase>
</template>

<script setup>
import CardBase from '@/Common/Layout/Containers/CardBase.vue'
import DescriptionList from '@/Common/DataDisplay/DescriptionLists/DescriptionList.vue'
import DescriptionListItem from '@/Common/DataDisplay/DescriptionLists/DescriptionListItem.vue'
import CardHeadingWithDescriptionAction from '@/Common/Headings/CardHeadings/CardHeadingWithDescriptionAction.vue'
import DropdownBase from '@/Common/Elements/Dropdowns/DropdownBase.vue'
import DropdownItemGroup from '@/Common/Elements/Dropdowns/DropdownItemGroup.vue'
import DropdownItem from '@/Common/Elements/Dropdowns/DropdownItem.vue'
import DropdownButton from '@/Common/Elements/Dropdowns/DropdownButton.vue'
import { ref } from 'vue'
import HoldFormModal from './HoldFormModal.vue'
import { Inertia } from '@inertiajs/inertia'

const props = defineProps({
  hold: Object,
})

const showingHoldFormModal = ref(false)

function deleteHold() {
  Inertia.delete(route('holds.destroy', props.hold))
}
</script>
